import { Box, Typography } from "@mui/material";

import { formatNumber, formatPercentage, formatPrice } from "../../../utility/formatters";

const ArcCoPaymentSummaryBox = ({
  title,
  value,
  formatType = "price",
  formatOptions = {},
  valueColor = "inherit",
  sx = {},
}) => {
  const formatValue = () => {
    switch (formatType) {
      case "percentage":
        return formatPercentage(value, formatOptions.places || 0);
      case "number":
        return formatNumber(value, formatOptions.places || 0);
      case "price":
      default:
        return formatPrice(value, formatOptions.places || 0);
    }
  };

  return (
    <Box
      className="arc-co-payment-summary-box"
      sx={{
        backgroundColor: "grey.100",
        borderRadius: "0.5rem",
        borderColor: "grey.200",
        padding: { xs: "8px 10px", sm: "14px 16px" },
        borderWidth: 1,
        borderStyle: "solid",
        alignContent: "center",
        ...sx,
      }}
    >
      <Typography
        color="text.secondary"
        className="arc-co-data-label"
        sx={{
          textAlign: "center",
          marginBottom: "4px",
          textTransform: "uppercase",
        }}
      >
        {title}
      </Typography>

      <Typography
        className="arc-co-data-value"
        sx={{
          color: valueColor,
          whiteSpace: "nowrap",
        }}
      >
        {formatValue()}
      </Typography>
    </Box>
  );
};

export default ArcCoPaymentSummaryBox;
